import { useAuth } from "@clerk/clerk-react"
import { useEffect } from "react"
import { setClerkTokenGetter } from "../utils/clerk-token-provider"

/**
 * Component that registers Clerk's getToken function globally
 * so that legacy API utilities (create-endpoint.ts) can access it
 */
export function ClerkTokenSetup({ children }: { children: React.ReactNode }) {
  const { getToken } = useAuth()

  useEffect(() => {
    setClerkTokenGetter(getToken)
  }, [getToken])

  return <>{children}</>
}
